import { render, staticRenderFns } from "./TrophyEdit.vue?vue&type=template&id=54e24684&"
import script from "./TrophyEdit.vue?vue&type=script&lang=ts&"
export * from "./TrophyEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports